import React from 'react';

// ─────────────────────────────────────────────────────────────────────────────
// PRIMITIVOS
// Valores base del sistema de color. No se usan directamente en componentes —
// se consumen a través de los tokens semánticos de abajo.
// ─────────────────────────────────────────────────────────────────────────────

const primitives = {
  purpleSurface: '#F2EDFE', // fondo suave violeta (accentSurface, secondary btn bg)
  purple: '#7C3BED', // color accent único del diseño
  purple10: 'rgba(124, 59, 237, 0.10)', // Preview bg — violeta al 10%

  slate50: '#F1F5F9',
  slate100: '#E2E8F0',
  slate200: '#CBD5E1',
  slate400: '#94A3B8',
  slate500: '#64748B',
  slate600: '#475569',
  slate700: '#334155',
  slate900: '#0F172A',

  white: '#FFFFFF',
  canvasBg: '#F7F7F8'
} as const;

// ─────────────────────────────────────────────────────────────────────────────
// TOKENS SEMÁNTICOS
// Describen el *propósito*, no el color. Si el diseño cambia, solo tocamos acá.
// ─────────────────────────────────────────────────────────────────────────────

// Superficies y fondos
export const C = {
  // Layout
  appBg: primitives.canvasBg, // fondo detrás del lienzo
  bg: primitives.white, // fondo general de paneles/sidebar
  surface: primitives.slate50, // superficie elevada (inputs, chips)

  // Bordes
  border: primitives.slate200, // borde estándar
  borderHi: primitives.slate400, // borde con más contraste (focus, hover)

  // Texto
  textPrimary: primitives.slate900,
  textSecondary: primitives.slate600,
  textMuted: primitives.slate400,

  // Accent (violeta)
  accent: primitives.purple,
  accentSurface: primitives.purpleSurface,
  accentText: primitives.purple,
  accentBorder: primitives.purpleSurface,

  // Danger
  danger: '#E05252',
  dangerSurface: 'rgba(224,82,82,0.08)',
  dangerBorder: 'rgba(224,82,82,0.20)',

  // Panel flotante (settings panel, etc.)
  panelBg: primitives.white,
  panelBorder: primitives.slate100,
  panelSelectedBg: primitives.purpleSurface,
  panelSelectedText: primitives.purple,

  // Timeline / layers panel
  timelineBg: primitives.white,
  timelineBorder: primitives.slate100,
  trackColors: ['#C9E9F9', '#DFD3F9'] as string[],
  trackBorderColors: ['#9ED9F5', '#D4C2F8'] as string[]
} as const;

// ─────────────────────────────────────────────────────────────────────────────
// BOTONES — 3 variantes del diseño
// btn1: primario   (fondo violeta, texto blanco)
// btn2: secundario (fondo purple50, texto purple600)
// btn3: ghost      (fondo slate50, texto slate400)
// ─────────────────────────────────────────────────────────────────────────────

export const BTN = {
  // Export — fondo #7C3BED, texto blanco
  primary: {
    bg: primitives.purple,
    text: primitives.white
  },
  // Preview — fondo #7C3BED al 10%, texto #7C3BED
  secondary: {
    bg: primitives.purple10,
    text: primitives.purple
  },
  // Saved to Cloud — fondo #F1F5F9, texto #64748B
  ghost: {
    bg: primitives.slate50,
    text: primitives.slate500
  }
} as const;

// ─────────────────────────────────────────────────────────────────────────────
// TIPOGRAFÍA
// ─────────────────────────────────────────────────────────────────────────────

const INTER_STACK = "'Inter', sans-serif";
export const FONT = INTER_STACK;
export const FONT_UI = INTER_STACK;
